export default "__VITE_ASSET__CVTa9LDf__"